let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eYGV1"), load("38Uf2"), load("6CN9M"), load("78EJ0")]).then(() => parcelRequire('c0sxZ'));